import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
// @ts-expect-error untyped module
import { getAppContext } from '../../../selectors/app';
// @ts-expect-error untyped module
import { push } from '../../../utils/history';
// @ts-expect-error untyped module
import { getCatalogServiceTrackingName } from '../../../utils/i18n';
// @ts-expect-error untyped module
import { OfficeLocationType } from '../../../constants/search/Filters';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { registerQuery, useQuery } from 'data-fetching-client';
import { SearchIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Wizard } from 'foundations-components/transitional/components/Wizard';
import { GET_USER_INSIGHTS } from 'marketplace-ui-reviews/queries/userInsightsQuery';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { marketplaceSearchProfiles } from '../../../clients/marketplaceSearchClient';
import { storefrontFiltersInitialState } from '../../../constants/StorefrontFilters';
import * as FilterKey from '../../../constants/search/FilterKey';
import { COUNTRY, SERVICE } from '../../../constants/search/FilterKey';
import { RELEVANCE_DESC } from '../../../constants/search/SortField';
import StorefrontUsageTrackerContext from '../../../context/StorefrontUsageTrackerContext';
import { getServices } from '../../../slices/serviceCatalogSlice';
import { getRecentActivity, setRecentActivity } from '../../../utils/homepage';
import { fromFilterStateToLocation, fromFilterStateToQuery } from '../../../utils/storefrontFilters';
import CountryStep from './FindPartnerWizardCountryStep';
import FindPartnerWizardFooter from './FindPartnerWizardFooter';
import IndustryStep from './FindPartnerWizardIndustryStep';
import LanguageStep from './FindPartnerWizardLanguageStep';
import ServiceStep from './FindPartnerWizardServiceStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StepComponents = [ServiceStep, IndustryStep, CountryStep, LanguageStep];
const StepKeys = ['service', 'industry', 'country', 'language'];
const GET_PROFILES = registerQuery({
  args: ['filters'],
  fieldName: 'profiles',
  fetcher: ({
    filters
  }) => {
    return marketplaceSearchProfiles(fromFilterStateToQuery(filters));
  }
});
export default function FindPartnerWizard({
  isMobileView,
  onClose
}) {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const catalogServices = useSelector(getServices);
  const appContext = useSelector(getAppContext);
  const [step, setStep] = useState(0);
  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
  const [filters, setFilters] = useState(Object.assign({}, storefrontFiltersInitialState, {
    [FilterKey.SORTS]: RELEVANCE_DESC
  }));
  const [profileCount, setProfileCount] = useState(0);
  const [showProfileCount, setShowProfileCount] = useState(false);
  const trackQuestionnaireInteraction = useCallback((action, subscreen) => {
    trackInteraction(action, Object.assign({}, storefrontFiltersInitialState, filters, {
      service: filters[SERVICE].map(id => getCatalogServiceTrackingName(id, catalogServices)),
      subscreen
    }));
  }, [catalogServices, filters, trackInteraction]);
  const handleClickSkip = useCallback(() => {
    const stepKey = StepKeys[step];
    setFilters(Object.assign({}, filters, {
      [stepKey]: storefrontFiltersInitialState[stepKey]
    }));
    setStep(step + 1);
    trackQuestionnaireInteraction('skip questionnaire step', stepKey);
  }, [filters, step, trackQuestionnaireInteraction]);
  const handleClickNext = useCallback(({
    target: {
      value
    }
  }) => {
    const stepKey = StepKeys[step];
    setStep(value);
    // don't set 'type' field until the questionnaire is finished
    setRecentActivity({
      questionnaireFilters: filters
    });
    trackQuestionnaireInteraction('save questionnaire step', stepKey);
  }, [filters, step, trackQuestionnaireInteraction]);
  const handleClickSubmit = useCallback(closeConfirmation => {
    onClose();
    setRecentActivity({
      type: 'questionnaire',
      questionnaireFilters: filters,
      viewedProfiles: []
    });
    trackQuestionnaireInteraction('submit questionnaire', closeConfirmation ? 'close confirmation' : 'language');
    const {
      pathname,
      search
    } = fromFilterStateToLocation(filters, catalogServices);
    push({
      pathname,
      search: `?ref=questionnaire${search.replace('?', '&')}`
    });
  }, [catalogServices, filters, onClose, trackQuestionnaireInteraction]);
  useEffect(() => {
    const storedFilters = getRecentActivity();
    if (storedFilters && storedFilters.questionnaireFilters) {
      setFilters(storedFilters.questionnaireFilters);
    }
  }, []);
  const {
    data: profilesData
  } = useQuery(GET_PROFILES, {
    variables: {
      filters
    }
  });
  const {
    data: insightsData
  } = useQuery(GET_USER_INSIGHTS, {
    variables: {
      appContext
    }
  });
  const userInsights = useMemo(() => insightsData === null || insightsData === void 0 ? void 0 : insightsData.userInsights, [insightsData]);
  useEffect(() => {
    if (profilesData) {
      setProfileCount(profilesData.profiles[0].total);
      setShowProfileCount(!!filters.service.length || !!filters.industry.length || !!filters.country || !!filters.language.length);
    }
  }, [profilesData, filters]);
  const WizardFooter = useCallback(_ref => {
    let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/_jsx(FindPartnerWizardFooter, Object.assign({}, props, {
      disableNextButton: !filters[StepKeys[step]].length,
      onClickSkip: handleClickSkip
    }));
  }, [filters, handleClickSkip, step]);
  const WizardHeader = useCallback(({
    wizardProps
  }) => {
    const {
      onReject
    } = wizardProps;
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      inlineSize: "100%",
      backgroundColor: "fill-surface-raised",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderStartEndRadius: "200",
      borderStartStartRadius: "200",
      paddingBlock: showProfileCount ? '500' : '800',
      marginBlockEnd: "500",
      children: [/*#__PURE__*/_jsx(NanoProgress, {
        "aria-label": unescapedText('ecosystem-marketplace-solutions-ui.homepage.questionnaire.progressBarAccessibleLabel'),
        value: (step + 1) / StepComponents.length * 100,
        height: 6
      }), showProfileCount && /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        direction: "column",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.matching",
          options: {
            count: profileCount
          }
        })
      }), /*#__PURE__*/_jsx(CloseButton, {
        color: "do-not-use-eerie",
        onClick: () => onReject()
      })]
    });
  }, [profileCount, showProfileCount, step]);
  const handleFilterChange = useCallback((key, value) => {
    let newFilters = Object.assign({}, filters, {
      [key]: value
    });
    if (key === COUNTRY && value === 'ANY') {
      newFilters = Object.assign({}, newFilters, {
        office_location: OfficeLocationType.ANY
      });
    }
    setFilters(newFilters);
  }, [filters]);
  const renderedCloseConfirmation = useMemo(() => {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      blockSize: "523px",
      children: [/*#__PURE__*/_jsx(WizardHeader, {
        stepProps: {
          heading: `${step}`
        },
        wizardProps: {
          onReject: () => onClose()
        }
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        paddingBlockEnd: "1500",
        paddingInline: "1400",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Illustration, {
          name: "approvals",
          width: "30%"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.close.title"
          })
        }), /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          direction: isMobileView ? 'column' : 'row',
          marginBlockStart: "500",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: () => setShowCloseConfirmation(false),
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.close.continue"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginInline: "300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.close.or"
            })
          }), /*#__PURE__*/_jsxs(Button, {
            onClick: () => handleClickSubmit(true),
            use: "secondary",
            children: [/*#__PURE__*/_jsx(SearchIcon, {
              size: "300"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.close.search"
            })]
          })]
        }), /*#__PURE__*/_jsx(Button, {
          onClick: () => onClose(),
          marginBlockStart: "500",
          marginBlockEnd: "1000",
          use: "link-on-bright",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.close.close"
          })
        })]
      })]
    });
  }, [handleClickSubmit, isMobileView, onClose, step, WizardHeader]);
  return /*#__PURE__*/_jsx(Modal, {
    use: "conversational",
    width: 700,
    "data-test-id": "findPartnerWizard-dialog",
    children: showCloseConfirmation ? renderedCloseConfirmation : /*#__PURE__*/_jsx(Wizard, {
      footerComponent: WizardFooter,
      headerComponent: WizardHeader,
      onConfirm: handleClickSubmit,
      onStepIndexChange: handleClickNext,
      onReject: () => {
        if (filters.service.length) {
          setShowCloseConfirmation(true);
        } else {
          onClose();
        }
      },
      stepIndex: step,
      children: StepComponents.map((StepComponent, index) => /*#__PURE__*/_jsx(StepComponent, {
        filters: filters,
        onFilterChange: handleFilterChange,
        userInsights: userInsights
      }, index))
    })
  });
}